import { useQuery } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';

import { debugLinkedInQueryKeys } from './queryKeys';

export function useDebugLinkedInMessagesQuery(threadId: string | null) {
  return useQuery({
    queryKey: debugLinkedInQueryKeys.messages(threadId),
    queryFn: async () => {
      const { data } = await fetchClient.GET(
        '/debug/linkedin/threads/{threadId}/messages',
        { params: { path: { threadId: threadId! } } },
      );
      return data ?? [];
    },
    enabled: Boolean(threadId),
    refetchInterval: 2_000,
  });
}
